import { LayoutService } from './services/layout/layout.service';
import { TranslateService } from '@ngx-translate/core';
import {
    Component,
    DoCheck,
    HostListener,
    OnInit,
    AfterViewChecked,
} from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Platform } from '@angular/cdk/platform';
import { AccountService } from './services/account/account.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogLoaderComponent } from './components/dialog-loader/dialog-loader.component';
import { SwUpdate } from '@angular/service-worker';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, DoCheck, AfterViewChecked {
    title = 'la-calculatrice-aurep';
    isAuth: boolean = false;
    constructor(
        public router: Router,
        public translate: TranslateService,
        private platform: Platform,
        private layoutService: LayoutService,
        private accountService: AccountService,
        public dialog: MatDialog,
        private swUpdate: SwUpdate
    ) {
        this.layoutService.setSafeArea();
    }

    ngOnInit(): void {
        // language default
        this.translate.setDefaultLang('FR');
        this.translate.use(environment.language);
        this.isAuth = this.accountService.getIsAuth();
       
        this.openDialog();
        this.accountService.getUserData().then((data) => {
            this.closeDialog()
        })            

        // this.layoutService.onSafeAreaChange().subscribe((safeArea) => {
        //     document
        //         .getElementById('routerContainer')
        //         ?.setAttribute('style', `height:${safeArea}%;`);
        // });

        if (this.swUpdate.isEnabled)this.swUpdate.available.subscribe(() =>window.location.reload());
    }
    ngAfterViewChecked(): void {
        this.layoutService.hideAndShowFooter(
            window.innerHeight,
            this.platform.ANDROID ? screen.orientation.type : ''
        );
    }
    ngDoCheck(): void {
        this.layoutService.hideAndShowFooter(
            window.innerHeight,
            this.platform.ANDROID ? screen.orientation.type : ''
        );
        this.isAuth = this.accountService.getIsAuth();
    }
    
    openDialog() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.panelClass = 'loader-dialog';
        this.dialog.open(DialogLoaderComponent, dialogConfig);
    }
    closeDialog() {
        this.dialog.closeAll();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.layoutService.hideAndShowFooter(
            event.target.innerHeight,
            this.platform.ANDROID ? screen.orientation.type : ''
        );
    }
    @HostListener('window:load', ['$event'])
    onLoad(event: any) {
        this.layoutService.hideAndShowFooter(
            event.target.innerHeight,
            this.platform.ANDROID ? screen.orientation.type : ''
        );
    }
    @HostListener('click', ['$event'])
    onClick(event: any) {
        this.layoutService.hideAndShowFooter(
            event.target.innerHeight,
            this.platform.ANDROID ? screen.orientation.type : ''
        );
    }
}
